"use client";
import { jsxs as x, jsx as o } from "react/jsx-runtime";
import { createContext as p, useContext as w, useState as i, useMemo as v } from "react";
import y from "./root.js";
import { useId as S } from "@radix-ui/react-id";
const c = p(void 0), g = () => w(c);
function I({
  wrapperStyles: t = {},
  children: s,
  customStyles: d,
  styles: l
}) {
  const [n, u] = i(null), [r, m] = i(null), a = v(() => ({ shadowHost: n, rootElement: r }), [n, r]), h = S(), f = y.div;
  return /* @__PURE__ */ x(
    f,
    {
      id: `inkeep-shadow${h}`,
      ref: (e) => {
        e && u(e);
      },
      style: t,
      children: [
        /* @__PURE__ */ o(
          "style",
          {
            type: "text/css",
            dangerouslySetInnerHTML: {
              __html: `@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;900&display=swap');
      ${l}`
            }
          }
        ),
        d,
        /* @__PURE__ */ o(
          "div",
          {
            id: "inkeep-widget-root",
            ref: (e) => {
              e && m(e);
            },
            style: t,
            children: /* @__PURE__ */ o(c.Provider, { value: a, children: n && r && s })
          }
        )
      ]
    }
  );
}
const E = (t) => g() ? t.children : /* @__PURE__ */ o(I, { ...t });
export {
  E as InkeepShadow,
  I as InkeepShadowProvider,
  c as ShadowContext,
  g as useShadow
};
